import {BACKEND} from '../consts/backend';

export const getTemporalesMro = async () => {
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
    };
    try {
      const response = await fetch(`${BACKEND}/api/temporales-mro/getTemporalesMro`, requestOptions);
      if (!response.ok) {
        throw new Error('Error en la solicitud');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getTemporalesMro:', error);
      return [];
    }
};

export const updateTemporalesMro = async (row, usuario) => {
  var user = [usuario.email, usuario.name];
  
  const payload = {
    id: row.id,
    po_number: row.po_number || '',
    responsible: row.responsible || '',
    vendor: row.vendor || '',
    mercaderia_descripcion: row.mercaderia_descripcion || '',
    destination: row.destination || '',
    peso_bruto: row.peso_bruto || '',
    peso_neto: row.peso_neto || '',
    medidas_embalaje: row.medidas_embalaje || '',
    serial: row.serial || '',
    origen_mercaderia: row.origen_mercaderia || '',
    marca_modelo: row.marca_modelo || '',
    valor_declarar: row.valor_declarar || '',
    valor_reparacion: row.valor_reparacion || '',
    fecha_presentacion_expediente: row.fecha_presentacion_expediente || null,
    aprobation_date: row.aprobation_date || null,
    sicnea_days: row.sicnea_days || '',
    fecha_embarque: row.fecha_embarque || null,
    fecha_vencimiento_temporal: row.fecha_vencimiento_temporal || null,
    fecha_presentacion_prorroga: row.fecha_presentacion_prorroga || null,
    fecha_aprobacion_prorroga: row.fecha_aprobacion_prorroga || null,
    dias_habilitados_prorroga: row.dias_habilitados_prorroga || '',
    due_date: row.due_date || null,
    fecha_retorno: row.fecha_retorno || null,
    status: row.status || '',
    ET: row.ET || '',
    IC: row.IC || '',
    po_servicio: row.po_servicio || '',
    custom_declaration: row.custom_declaration || '',
    channel: row.channel || '',
    local_delivery_note: row.local_delivery_note || '',
    custom_doc_date: row.custom_doc_date || null,
    release_date: row.release_date || null,
    delivery_date: row.delivery_date || null,
    comentario: row.comentario || '',
    documents: row.documents || 0,
    es_envase: row.es_envase || 0,
    despacho_envase: row.despacho_envase || '',
    fecha_presentacion_expediente_envase: row.fecha_presentacion_expediente_envase || null,
    fecha_aprobacion_expediente_envase: row.fecha_aprobacion_expediente_envase || null,
    dias_habilitados_sicnea_envase: row.dias_habilitados_sicnea_envase || '',
    fecha_embarque_envase: row.fecha_embarque_envase || null,
    fecha_vencimiento_temporal_envase: row.fecha_vencimiento_temporal_envase || null,
    fecha_vencimiento_envase: row.fecha_vencimiento_envase || null,
    user: user
  };
  
  const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      redirect: 'follow',
  };
  try {
      const response = await fetch(`${BACKEND}/api/temporales-mro/updateTemporalesMro`, requestOptions);
      const result = await response.json();
      
      if (!response.ok) {
          throw new Error(result.message || 'Error en la solicitud');
      }
      
      // Considerar éxito si status es "success" o "warning" (el logging falló pero la operación principal fue exitosa)
      if (result.status === 'success' || result.status === 'warning') {
          if (result.status === 'warning') {
              console.warn('Operación completada con advertencia:', result.message);
              return false;
          }
          return true;
      }
      
      throw new Error(result.message || 'Error desconocido');
  } catch (error) {
      console.error('Error en updateTemporalesMro:', error.message || error);
      return false;
  }
};

export const insertTemporalesMro = async (row, usuario) => {
  var user = [usuario.email, usuario.name];
  
  const payload = {
    po_number: row.po_number || '',
    responsible: row.responsible || '',
    vendor: row.vendor || '',
    mercaderia_descripcion: row.mercaderia_descripcion || '',
    destination: row.destination || '',
    peso_bruto: row.peso_bruto || '',
    peso_neto: row.peso_neto || '',
    medidas_embalaje: row.medidas_embalaje || '',
    serial: row.serial || '',
    origen_mercaderia: row.origen_mercaderia || '',
    marca_modelo: row.marca_modelo || '',
    valor_declarar: row.valor_declarar || '',
    valor_reparacion: row.valor_reparacion || '',
    fecha_presentacion_expediente: row.fecha_presentacion_expediente || null,
    aprobation_date: row.aprobation_date || null,
    sicnea_days: row.sicnea_days || '',
    fecha_embarque: row.fecha_embarque || null,
    fecha_vencimiento_temporal: row.fecha_vencimiento_temporal || null,
    fecha_presentacion_prorroga: row.fecha_presentacion_prorroga || null,
    fecha_aprobacion_prorroga: row.fecha_aprobacion_prorroga || null,
    dias_habilitados_prorroga: row.dias_habilitados_prorroga || '',
    due_date: row.due_date || null,
    fecha_retorno: row.fecha_retorno || null,
    status: row.status || '',
    ET: row.ET || '',
    IC: row.IC || '',
    po_servicio: row.po_servicio || '',
    custom_declaration: row.custom_declaration || '',
    channel: row.channel || '',
    local_delivery_note: row.local_delivery_note || '',
    custom_doc_date: row.custom_doc_date || null,
    release_date: row.release_date || null,
    delivery_date: row.delivery_date || null,
    comentario: row.comentario || '',
    documents: row.documents || 0,
    es_envase: row.es_envase || 0,
    despacho_envase: row.despacho_envase || '',
    fecha_presentacion_expediente_envase: row.fecha_presentacion_expediente_envase || null,
    fecha_aprobacion_expediente_envase: row.fecha_aprobacion_expediente_envase || null,
    dias_habilitados_sicnea_envase: row.dias_habilitados_sicnea_envase || '',
    fecha_embarque_envase: row.fecha_embarque_envase || null,
    fecha_vencimiento_temporal_envase: row.fecha_vencimiento_temporal_envase || null,
    fecha_vencimiento_envase: row.fecha_vencimiento_envase || null,
    user: user
  };

  const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      redirect: 'follow',
  };
  try {
      const response = await fetch(`${BACKEND}/api/temporales-mro/insertTemporalesMro`, requestOptions);
      const result = await response.json();
      
      if (!response.ok) {
          throw new Error(result.message || 'Error en la solicitud');
      }
      
      if (result.status === 'success' || result.status === 'warning') {
          if (result.status === 'warning') {
              console.warn('Operación completada con advertencia:', result.message);
              return false;
          }
          return true;
      }
      
      throw new Error(result.message || 'Error desconocido');
  } catch (error) {
      console.error('Error en insertTemporalesMro:', error.message || error);
      return false;
  }
};

export const deleteTemporalesMro = async (id, usuario, row) => {
  var user = [usuario.email, usuario.name];
  
  const payload = {
    id: id,
    po_number: row.po_number,
    user: user
  };

  const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      redirect: 'follow',
  };
  try {
      const response = await fetch(`${BACKEND}/api/temporales-mro/deleteTemporalesMro`, requestOptions);
      const result = await response.json();
      
      if (!response.ok) {
          throw new Error(result.message || 'Error en la solicitud');
      }
      
      if (result.status === 'success' || result.status === 'warning') {
          if (result.status === 'warning') {
              console.warn('Operación completada con advertencia:', result.message);
              return false;
          }
          return true;
      }
      
      throw new Error(result.message || 'Error desconocido');
  } catch (error) {
      console.error('Error en deleteTemporalesMro:', error.message || error);
      return false;
  }
};

export const getHistoryTemporal = async (row) => {
  const payload = {
    po_number: row.po_number
  };

  const requestOptions = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    redirect: 'follow',
  };
  
  try {
    const response = await fetch(`${BACKEND}/api/temporales-mro/getHistoryTemporal`, requestOptions);
    if (!response.ok) {
      throw new Error('Error en la solicitud');
    }

    const data = await response.json();

    if (data.status === "success") {
      return data.result;  // <-- ahora devuelve los datos reales
    } else {
      console.error('Error en getHistoryTemporal:', data.message);
      return null;
    }
  } catch (error) {
    console.error('Error en getHistoryTemporal:', error);
    return null;
  }
};

export const updateTemporalesMroDocuments = async (po_number, documents_value = 1) => {
  const payload = {
    po_number: po_number,
    documents: documents_value
  };

  const requestOptions = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      redirect: 'follow',
  };
  try {
      const response = await fetch(`${BACKEND}/api/temporales-mro/updateTemporalesMroDocuments`, requestOptions);
      const result = await response.json();
      
      if (!response.ok) {
          throw new Error(result.message || 'Error en la solicitud');
      }
      
      if (result.status === 'success' || result.status === 'warning') {
          if (result.status === 'warning') {
              console.warn('Operación completada con advertencia:', result.message);
          }
          return true;
      }
      
      throw new Error(result.message || 'Error desconocido');
  } catch (error) {
      console.error('Error en updateTemporalesMroDocuments:', error.message || error);
      return false;
  }
};

export const insertTypeFileMro = async ({ id_orden, id_file, type, po_number, file_name }) => {
  const payload = {
    id_orden: id_orden || null,
    id_file: id_file || null,
    type,
    po_number: po_number || null,
    file_name: file_name || null,
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${BACKEND}/api/temporales-mro/insertTypeFileMro`, requestOptions);
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Error al asignar tipo de archivo');
    }
    return result;
  } catch (error) {
    console.error('Error en insertTypeFileMro:', error.message || error);
    return { status: 'error', message: error.message };
  }
};

export const updateTypeFileMro = async ({ id_file, type }) => {
  const payload = {
    id_file,
    type,
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${BACKEND}/api/temporales-mro/updateTypeFileMro`, requestOptions);
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Error al actualizar tipo de archivo');
    }
    return result;
  } catch (error) {
    console.error('Error en updateTypeFileMro:', error.message || error);
    return { status: 'error', message: error.message };
  }
};

export const getDocumentsTypeMro = async (po_number) => {
  const payload = { po_number };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${BACKEND}/api/temporales-mro/getDocumentsTypeMro`, requestOptions);
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || 'Error al obtener tipos de documentos');
    }
    return result.data || [];
  } catch (error) {
    console.error('Error en getDocumentsTypeMro:', error.message || error);
    return [];
  }
};

